/**
 * Current version of the Terms of Service and Privacy Policy.
 * Increment this when terms are updated to trigger re-consent flow.
 */
export const CURRENT_TERMS_VERSION = '1.0';
